<div class="alert-container" [ngClass]="type">
  <span class="icon" [ngClass]="type"></span>
  <span class="message" [innerHTML]="message | transloco: params | safeHtml" appRouteTransformer></span>
  <button mat-button (click)="close()">{{'BUTTONS.CLOSE' | transloco}}</button>
</div>
